/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Price_No_Bookings_BodyInputs */

const es_landing_price_no_bookings_body = /** @type {(inputs: Landing_Price_No_Bookings_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para ti es gratis hasta que tu barco trabaja: solo cuesta cuando te paga a ti.`)
};

const gl_landing_price_no_bookings_body = /** @type {(inputs: Landing_Price_No_Bookings_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para ti é de balde ata que o teu barco traballa: só custa cando che paga a ti.`)
};

const en_landing_price_no_bookings_body = /** @type {(inputs: Landing_Price_No_Bookings_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It costs you nothing until your boat earns: you only pay when it pays you.`)
};

/**
* | output |
* | --- |
* | "It costs you nothing until your boat earns: you only pay when it pays you." |
*
* @param {Landing_Price_No_Bookings_BodyInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_price_no_bookings_body = /** @type {((inputs?: Landing_Price_No_Bookings_BodyInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Price_No_Bookings_BodyInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_price_no_bookings_body(inputs)
	if (locale === "en") return en_landing_price_no_bookings_body(inputs)
	return es_landing_price_no_bookings_body(inputs)
});